<template>
  <vs-row v-if="files">
    <vx-card
      no-shadow
      card-border
      :subtitle="title ? title : $t('upload_files.attachments')"
      v-if="files.length"
    >
      <vs-row class="mb-3 grid lg:grid-cols-4 md:grid-cols-3 grid-cols-1 gap-4">
        <vs-button
          v-for="(file, indextr) in files"
          :key="indextr"
          @click="downloadFile(file)"
          class="vs-con-loading__container"
          :id="`file-${file}`"
          type="border"
          size="small"
          :disabled="disables.includes(file)"
        >
          {{ $t('comments.download') }}{{ (indextr + 1) | persian_digits }}
        </vs-button>
      </vs-row>
    </vx-card>
  </vs-row>
</template>

<script>
export default {
  name: 'DownloadFiles',
  props: {
    files: Array,
    title: String
  },
  data() {
    return {
      disables: []
    }
  },
  methods: {
    downloadFile(fileId) {
      this.$vs.loading({
        container: `#file-${fileId}`,
        scale: 0.4
      })
      this.disables.push(fileId)
      this.$store.dispatch('file/downloadFile', fileId).then(response => {
        this.disables.splice(
          this.disables.findIndex(f => f === fileId),
          1
        )
        this.$vs.loading.close(`#file-${fileId} > .con-vs-loading`)
        window.open(response, '_blank')
      })
    }
  }
}
</script>
